
const saveTokens = (res) => {
    const token = res.headers.get('authorization');
    if(typeof token === "string" && token !== "") {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('refresh_token', res.headers.get('refreshtoken'));
    }
}

const saveTokensDataProvider = (headers) => {
    const token = headers.get('authorization');
    if(typeof token === "string" && token !== "") {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('refresh_token', headers.get('refreshtoken'));
    }
}

const token = sessionStorage.getItem('token');
const refresh_token = sessionStorage.getItem('refresh_token');

export { saveTokens, token, refresh_token, saveTokensDataProvider }

// import { saveTokens } from './utils/saveTokens';

// 'Authorization': `Bearer ${sessionStorage.getItem('token')}`,
// 'RefreshToken': `Bearer ${sessionStorage.getItem('refresh_token')}`,